import '../../css/blocks/glossary.css';

const scrollButton = document.getElementById('scrollButton');
const glossaryAnchors = document.querySelectorAll('[data-scroll-id]');

window.onscroll = function () {scrollFunction()};

glossaryAnchors.forEach(anchor => anchor.addEventListener('click', anchorScroll));

function scrollFunction() {
    if(document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        scrollButton.addEventListener('click', topScroll);
        scrollButton.style.display = "block";
    } else {
        scrollButton.removeEventListener('click', topScroll);
        scrollButton.style.display = "none";
    }
}

function topScroll() {
    location.hash = '';
    document.body.scrollTop = 0; // for Safari
    document.documentElement.scrollTop = 0; // for Chrome, Firefox and Opera
}

function scrollToAnchor(targetAnchorId) {
    let anchorElement = document.getElementById(targetAnchorId);
    anchorElement.scrollIntoView({behavior: 'smooth'});
}

function anchorScroll() {
    let targetAnchorId = this.dataset.scrollId;
    scrollToAnchor(targetAnchorId);
}